import './AnnotationView.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleLeft, faRedo, faUndo } from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { ProjectRole } from '../../../models/userRole.model';
import { CreateAnnotationContainer } from '../../../modules/annotation/containers/CreateAnnotation.container';
import { RedirectFromAnnotationContainer } from '../../../modules/annotation/containers/RedirectFromAnnotationContainer';
import { UnlockWorkspaceModal } from '../../../modules/workspaces/components/UnlockWorkspaceModal';
import { CurrentWorkspaceContainer } from '../../../modules/workspaces/containers/CurrentWorkspace.container';

library.add(faUndo, faRedo, faAngleLeft);

export const AnnotationCreateView = (): ReactElement => {
  return (
    <div className='annotation-view'>
      <CurrentWorkspaceContainer>{(unlockModalProps): ReactElement => <UnlockWorkspaceModal {...unlockModalProps} />}</CurrentWorkspaceContainer>
      <RedirectFromAnnotationContainer allowedRoles={[ProjectRole.Annotator, ProjectRole.Reviewer]} />
      <CreateAnnotationContainer />
    </div>
  );
};
